<template>
  <div class="cutedit-dialog">
    <div class="blur"></div>
    <div class="border">
      <!-- 顶部栏 -->
      <div class="titlebar">
        <div class="varname">{{titlename}}</div>
        <div class="header-actions">
          <div class="ai-button ai-button--primary"
               :class="(pen.polygons[pen.activeIndex].length > 0 || pen.activeIndex > 0)?'':'disabled'"
               @click="delPolyLastPoint">
            删除最后一个点
          </div>
          <div style="margin-left: 10px;" class="ai-button ai-button--primary"
               :class="(pen.polygons[pen.activeIndex].length > 0)?'':'disabled'"
               @click="clearPoly">
            清除
          </div>
        </div>
      </div>

      <!-- 主体内容区：左侧 Canvas，右侧侧边栏 -->
      <div class="editor-body">
        <div id="map-main1" class="map-main1">
          <div id="stage1" class="stage1">
            <canvas id="pixi1"></canvas>
          </div>
        </div>

        <div class="sidebar" @click.prevent.stop @wheel.stop>
          <div class="sidebar-header">
            <span class="label">选区名称</span>
            <span class="count">{{pen.polygons.filter(p => p.length >= 3).length}}个区域</span>
          </div>

          <div class="region-list">
            <div v-for="(poly, index) in pen.polygons" :key="index"
                 class="region-item">
              <span class="region-name">选区{{index + 1}} <small v-if="poly.length < 3">(未闭合)</small></span>
              <span class="delete-link" @click.stop="deleteRegion(index)">删除</span>
            </div>
          </div>

          <div class="sidebar-footer">
            <div class="ai-button ai-button--primary create-btn"
                 :class="{ disabled: pen.polygons[pen.activeIndex].length < 3 }"
                 @click="addPoly">
              +创建选区
            </div>

            <div class="sidebar-bottom-actions">
              <div class="ai-button" @click="onCancel">取 消</div>
              <div class="ai-button ai-button--primary" @click="onConfirm">确 认</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Container, Point, Application, Graphics, Sprite, Loader } from 'pixi.js';

export default {
  props: {
    itemData: { type: Object, default: null },
  },
  data() {
    return {
      titlename: 'test',
      app: null,
      sprite: null,
      imageorgData: { width: 0, height: 0 },
      imageurl: "https://robot-vr-public.cdn.bcebos.com/0390605c2ee1409ab6b076fe21427f2e/1610716139.png",
      mousedata: { down: false, moveing: false, d_x: null, d_y: null, over: false },
      pen: { polygons: [[]], activeIndex: 0, pointPen: null, linePen: null, pointColor: 0x00ff00, pointSize: 10, lineColor: 0x00ff00, lineSize: 4 }
    }
  },
  methods: {
    show() {
      this.titlename = this.itemData.name;
      this.initSprite();
    },
    addPoly() {
      const currentPoly = this.pen.polygons[this.pen.activeIndex];
      if (currentPoly.length < 3) {
        this.$message.warning("当前选区点数不足3个，无法闭合，请继续加点。");
        return;
      }
      this.pen.polygons.push([]);
      this.pen.activeIndex = this.pen.polygons.length - 1;
    },
    clearPoly() {
      this.pen.polygons[this.pen.activeIndex] = [];
      this.setup();
    },
    deleteRegion(index) {
      if (this.pen.polygons.length <= 1) {
        this.pen.polygons = [[]];
        this.pen.activeIndex = 0;
      } else {
        this.pen.polygons.splice(index, 1);
        if (this.pen.activeIndex >= this.pen.polygons.length) {
          this.pen.activeIndex = this.pen.polygons.length - 1;
        }
      }
      this.setup();
    },
    delPolyLastPoint() {
      const currentPoly = this.pen.polygons[this.pen.activeIndex];
      if (currentPoly.length > 0) {
        currentPoly.pop();
      } else if (this.pen.activeIndex > 0) {
        this.pen.polygons.pop();
        this.pen.activeIndex--;
      }
      this.setup();
    },
    onConfirm() {
      this.saveData();
      this.$emit('close');
    },
    saveData() {
      this.itemData.pen = {};
      this.itemData.pointArg = [];
      this.itemData.polygon = [];

      this.pen.polygons.forEach(poly => {
        if (poly.length < 3) return;

        const pointGroup = [];
        const polygonGroup = [];

        poly.forEach(pt => {
          pointGroup.push(new Point(pt.x, pt.y));
          polygonGroup.push([
            this.imageorgData.width * 0.5 + pt.x,
            this.imageorgData.height * 0.5 + pt.y
          ]);
        });

        this.itemData.pointArg.push(pointGroup);
        this.itemData.polygon.push(polygonGroup);
      });
      this.itemData.anchor = new Point(0.5, 0.5);
    },
    onCancel() {
      this.saveData();
      this.$emit('close');
    },
    initPan() {
      this.pen.pointPen = new Graphics();
      this.pen.linePen = new Graphics();
      this.sprite.addChild(this.pen.pointPen);
      this.sprite.addChild(this.pen.linePen);

      if (this.itemData.pointArg != null) {
        let rawPolygons = [];
        if (this.itemData.pointArg.length > 0 && !(this.itemData.pointArg[0] instanceof Array)) {
          rawPolygons = [this.itemData.pointArg];
        } else {
          rawPolygons = this.itemData.pointArg;
        }

        const oldAnchorX = (this.itemData.anchor && this.itemData.anchor.x !== undefined) ? this.itemData.anchor.x : 0;
        const oldAnchorY = (this.itemData.anchor && this.itemData.anchor.y !== undefined) ? this.itemData.anchor.y : 0;

        const offsetX = (oldAnchorX - 0.5) * this.imageorgData.width;
        const offsetY = (oldAnchorY - 0.5) * this.imageorgData.height;

        this.pen.polygons = rawPolygons.map(group =>
          group.map(p => new Point(p.x + offsetX, p.y + offsetY))
        );

        if (this.pen.polygons.length === 0) this.pen.polygons = [[]];
        this.pen.activeIndex = this.pen.polygons.length - 1;
        this.setup();
      } else {
        this.pen.polygons = [[]];
        this.pen.activeIndex = 0;
      }
    },
    setup() {
      this.pen.pointPen.clear();
      this.pen.linePen.clear();

      this.pen.polygons.forEach((poly, index) => {
        if (poly.length > 0) {
          for (var i = 0; i < poly.length; i++) {
            this.drawPoint(poly[i].x, poly[i].y, index)
          }
          this.drawLine(this.pen.linePen, true, poly);
        }
      });
    },
    drawPoint(x, y, polygonIndex) {
      const color = this.pen.pointColor;
      this.pen.pointPen.beginFill(color, 0.001)
      this.pen.pointPen.lineStyle(this.pen.lineSize, color)
      this.pen.pointPen.drawCircle(x, y, this.pen.pointSize);
      this.pen.pointPen.endFill();
    },
    drawLine(graphic, show, points) {
      if (!points || points.length === 0) return;
      graphic.beginFill(0x00ff00, 0.001);
      if (show) graphic.lineStyle(this.pen.lineSize, this.pen.lineColor)
      graphic.moveTo(points[0].x, points[0].y)
      for (let i = 0; i < points.length; i++) {
        graphic.lineTo(points[i].x, points[i].y);
      }
      graphic.lineTo(points[0].x, points[0].y);
      graphic.endFill();
    },
    async initSprite() {
      if (this.sprite != null) {
        let index = this.app.stage.getChildIndex(this.sprite);
        if (index != -1) {
          this.app.stage.removeChild(this.sprite);
        }
      }

      this.sprite = Sprite.from(this.itemData.plymap);
      const p = new Promise(resolve => {
        const img = new Image()
        img.onload = e => {
          this.imageorgData.width = img.width;
          this.imageorgData.height = img.height;
          resolve()
        }
        img.src = this.itemData.plymap
      })
      await p

      const stage = document.getElementById('stage1');
      const containerWidth = stage.clientWidth;
      const containerHeight = stage.clientHeight;
      this.app.renderer.resize(containerWidth, containerHeight);

      const displayWidth = Math.min(800, containerWidth * 0.9);
      this.sprite.width = displayWidth;
      this.sprite.height = this.sprite.height * this.sprite.width / this.imageorgData.width;

      this.sprite.anchor.set(0.5);

      this.sprite.x = containerWidth / 2;
      this.sprite.y = containerHeight / 2;

      this.app.stage.addChild(this.sprite);
      this.sprite.interactive = true;
      this.initPan();

      this.sprite.on('click', (event) => {
        if (!this.mousedata.moveing) {
          var localP = new Point(0, 0);
          event.data.getLocalPosition(this.sprite, localP, event.data.global);
          this.pen.polygons[this.pen.activeIndex].push(new Point(localP.x, localP.y))
          this.setup();
        }
      });

      this.sprite.on('mousedown', (event) => {
        this.mousedata.down = true;
        this.mousedata.d_x = event.data.global.x;
        this.mousedata.d_y = event.data.global.y;
      });

      this.sprite.on('mouseup', (event) => {
        this.mousedata.down = false;
        if (this.timer) return
        this.timer = setTimeout(() => {
          this.mousedata.moveing = false;
          clearTimeout(this.timer)
          this.timer = null
        }, 50)
      });

      this.sprite.on('mouseover', () => { this.mousedata.over = true; });
      this.sprite.on('mouseout', () => { this.mousedata.over = false; });
      this.sprite.on('mouseupoutside', () => { this.mousedata.over = false; });

      this.sprite.on('mousemove', (event) => {
        if (this.mousedata.down) {
          this.mousedata.moveing = true;
          let dx = event.data.global.x - this.mousedata.d_x;
          let dy = event.data.global.y - this.mousedata.d_y;
          this.sprite.x += dx;
          this.sprite.y += dy;
          this.mousedata.d_x = event.data.global.x;
          this.mousedata.d_y = event.data.global.y;
        }
      });
    }
  },
  mounted() {
    var stage = document.getElementById('stage1');
    var canvas = document.getElementById('pixi1');
    this.app = new Application({
      width: stage.clientWidth,
      height: stage.clientHeight,
      antialias: true,
      transparent: true,
      view: canvas,
    });

    document.addEventListener('mousewheel', (e) => {
      if (null === this.sprite) return;
      if (e.wheelDelta > 0 && this.mousedata.over) {
        this.sprite.scale.set(this.sprite.scale.x + 0.1, this.sprite.scale.y + 0.1)
      }
      if (e.wheelDelta < 0 && this.sprite.scale.x > 0.3) {
        this.sprite.scale.set(this.sprite.scale.x - 0.1, this.sprite.scale.y - 0.1)
      }
    }, false);
  }
}
</script>

<style lang="scss" scoped>
.cutedit-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blur {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.border {
  width: 1100px;
  height: 750px;
  background-color: #fff;
  position: relative;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.titlebar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;

  .varname {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .header-actions {
    display: flex;
  }
}

.editor-body {
  flex: 1;
  display: flex;
  background-color: #f5f7fa;
  overflow: hidden;
}

.map-main1 {
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #888; /* 模拟中心灰色背景 */
}

.stage1 {
  width: 800px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.sidebar {
  width: 260px;
  background-color: #fff;
  border-left: 1px solid #eee;
  display: flex;
  flex-direction: column;
  padding: 20px;

  .sidebar-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    font-size: 14px;
    color: #666;

    .count {
      color: #999;
    }
  }

  .region-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 20px;

    .region-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 15px;
      background-color: #f8f9fb;
      border-radius: 4px;
      margin-bottom: 10px;
      border: 1px solid transparent;
      cursor: pointer;

      &.active {
        border-color: #409eff;
        background-color: #ecf5ff;
      }

      .region-name {
        font-size: 14px;
        color: #333;
        small {
          color: #ff4d4f;
          margin-left: 4px;
        }
      }

      .delete-link {
        font-size: 13px;
        color: #409eff;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .sidebar-footer {
    .create-btn {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      margin-bottom: 20px;
    }

    .sidebar-bottom-actions {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #eee;
      padding-top: 20px;

      .ai-button {
        width: 45%;
      }
    }
  }
}

.ai-button {
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  text-align: center;

  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }

  &--primary {
    background-color: #2499d9;
    border-color: #2499d9;
    color: #fff;

    &:hover {
      background-color: #35aae6;
      border-color: #35aae6;
      color: #fff;
    }
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
